import { InjectionToken } from '@angular/core';

export const RUNTIME_ENV = new InjectionToken<any>('RUNTIME_ENV');
